"use strict";

define('evisions/redactor.plugins/href.location.redactor.plugin',[], function () {
  if (typeof window.RedactorPlugins === 'undefined') window.RedactorPlugins = {};
  window.RedactorPlugins.hrefLocation = {
    init: function init() {
      var old = this.linkShow;
      this.linkShow = function () {
        _.defer(function () {
          var cb = $('#redactor_link_blank');
          cb.prop('checked', true);
          cb.parent().attr('style', 'display: none !important');
        });
        return old.apply(this, arguments);
      };
    }
  };
  return RedactorPlugins;
});

